export default __webpack_public_path__ + "static/media/apvs-note.687dad29.webp";